export { default } from "-!./fancypass.ts?vue&type=script&lang=ts&external"; export * from "-!./fancypass.ts?vue&type=script&lang=ts&external"